export default "__VITE_ASSET__87cb7609__"